module.exports = __webpack_public_path__ + "img/18.6e3efdc4.jpg";